/*
 * @Author: zhouhm 1148305943@qq.com
 * @Date: 2022-06-14 10:41:53
 * @LastEditors: zhouhm 1148305943@qq.com
 * @LastEditTime: 2025-08-25 17:11:30
 * @FilePath: \roadcqc-mobile\src\pages\lq\realtime\checkVideo.ctrl.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BaseCtrl from "_pages/common/baseCtrl";
import {dateFormat} from "_services/transformers";

export default class LqRollRealTimeCloudPictureCtrl extends BaseCtrl {
    constructor($scope, $rootScope,$stateParams){
        super();
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.stateParams=$stateParams;
        //console.log(this.rootScope);
        console.log(this.stateParams);
        this.rollCloudPicture = {
            // 工区
            workAreaId: this.rootScope.cloudpicture?this.rootScope.cloudpicture.workAreaId:this.rootScope.currentWorkArea?this.rootScope.currentWorkArea.id:'',

        };

        this.url=`https://tpj-monitor.jsti-smart.cn/#/?workareaId=${this.rollCloudPicture.workAreaId}&site=2&authkey=${this.generateTimestampId()}`
        if(this.stateParams.url){
            this.url = this.stateParams.url ;
            document.title = this.stateParams.title ;
        }
        //console.log(this.url)
    }

    $onInit() {
        setTimeout(()=>{
            if(document.getElementById('iframe')){
                document.getElementById('iframe').src=this.url
            }
        },1000)
    }

    // 生成：当前时间戳 + 16位数字字母随机串
    generateTimestampId() {
        const timestamp = Date.now().toString();
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let rand = '';

        if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
            // 浏览器安全随机
            const arr = new Uint32Array(16);
            crypto.getRandomValues(arr);
            for (const n of arr) rand += chars[n % chars.length];
        } else {
            try {
                // Node.js 安全随机
                const { randomBytes } = require('crypto');
                const buf = randomBytes(16);
                for (const n of buf) rand += chars[n % chars.length];
            } catch (error) {
                // 兜底
                for (let i = 0; i < 16; i++) rand += chars[Math.floor(Math.random() * chars.length)];
            }
        }

        return timestamp + rand;
    }

    /**
     * 返回上级
     */
    goBack(){
        console.log('in')
        history.back();
    }
}

LqRollRealTimeCloudPictureCtrl.$inject = ['$scope', "$rootScope","$stateParams"]
